import { Pathology } from "../models/Pathology";
import client from "./axios";

const pathologiesUrl = `${window.__env.BASE_URL}/pathologies`;

export const Pathologies = {
  getPathologies: () => client.get<Pathology[]>(pathologiesUrl),
  getPathology: (id: string) => client.get<Pathology>(`${pathologiesUrl}/${id}`),
  createPathology: (pathology: Pathology) => client.post<Pathology>(`${pathologiesUrl}`, pathology),
  updatePathology: (pathology: Pathology) => client.put<Pathology>(`${pathologiesUrl}/${pathology.id}`, pathology),
  deletePathology: (id: number) => client.delete<Pathology>(`${pathologiesUrl}/${id}`),
}